$(document).ready(function () {
  document.addEventListener('variant:change', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    if(variant.available){
      $('.in-stock').show();
      $('.out-stock').hide();
    } else {
      $('.in-stock').hide();
      $('.out-stock').show();
    }
  });
  // $(function() {
  //   function handleFooterDisplay() {
  //     if ($(window).width() < 1000) {
  //       // Below 1000px
  //       $('.footer__block:not(.footer__block--no-dropdown) > p').click(function(){
  //         $(this).parent().toggleClass("active");
  //         $(this).next().slideToggle();
  //       });
  //     }
  //   }

  //   handleFooterDisplay();                 // Run on page load
  //   $(window).on('resize', handleFooterDisplay);  // Run on resize
  // });
  $(function() {
  function handleFooterDisplay() {
    if ($(window).width() < 1000) {
      // Below 1000px
      $('.footer__block:not(.footer__block--no-dropdown) > p')
        .off('click') // remove previous handlers
        .on('click', function() {
          $(this).parent().toggleClass("active");
          $(this).next().stop(true, true).slideToggle();
        });
    } else {
      // Optional: reset any open states when resizing back to desktop
      $('.footer__block').removeClass('active');
      $('.footer__block > ul, .footer__block > div').removeAttr('style');
      $('.footer__block:not(.footer__block--no-dropdown) > p').off('click');
    }
  }

  handleFooterDisplay();                        // Run on page load
  $(window).on('resize', handleFooterDisplay);  // Re-run on resize
});


});
